var React = require('react');

function AdobeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.175 4H34v28L22.175 4zm-8.336 0H2v28L13.839 4zm4.165 10.317l7.538 17.682h-4.939l-2.258-5.632h-5.517l5.176-12.05z"}));
}

AdobeIcon.defaultProps = {"viewBox":"0 0 36 36","focusable":"false","aria-hidden":"true","role":"img"};

module.exports = AdobeIcon;

AdobeIcon.default = AdobeIcon;
